import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../actions/organization";
import _ from "lodash";

import {
  Dialog,
  DialogContent,
  Button,
  TextField,
  DialogActions,
  Checkbox,
  FormControlLabel,
  Switch,
} from "@material-ui/core";
import sort from "fast-sort";
import IconEmail from "material-ui/svg-icons/communication/email";
import IconAddMember from "material-ui/svg-icons/social/person-add";
import Loader from "react-loader-advanced";
import AppFrame from "../Appframe/AppFrame";
import Subtitle from "../../components/common/Subtitle";
import InfoText from "../../components/common/InfoText";
import NormalFlatButton from "../../components/common/NormalFlatButton";
import EmailSender from "../../components/common/EmailSender";
import WrapDialogue from "../../components/common/WrapDialogue";
import InfoDialogue from "../../components/common/InfoDialogue";
import SectionTitle from "../../components/common/SectionTitle";
import layout from "../../styles/layout";

import { addMemberToOrganization } from "../../services/directcalls";
import colors, { colorsV2 } from "../../styles/colors";
import events from "../../services/events";

class ManageOrganizationMembers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orgId: props.organization.orgId,
      orgInfoData: props.organization.orgInfoData,
      orgMembers: [],
      addMemberRetMsg: "",
      newMemberOpen: false,
      grantMemberOpen: false,
      isProvider: true,
      filterText: "",
      firstName: "",
      lastName: "",
      email: "",
      successMessage: "",
      userToRemove: null,
    };

    this.viewMemberApps = this.viewMemberApps.bind(this);
    this.addNewMember = this.addNewMember.bind(this);
  }

  componentWillMount() {
    this.props.getAllMembersOfOrganization(this.props.userId, this.state.orgId);
  }

  componentWillReceiveProps(nextProps) {
    let orgMembers = nextProps.organization.members;
    if (orgMembers && this.state.orgMembers.length == 0) {
      this.setState({ orgMembers });
    }
  }

  sendOrganizationEmail() {
    let windowTitle = `Send Email to All the Members`;
    return (
      <div>
        <Button onClick={() => this.refs.sendEmailDialogue.open()}>
          <IconEmail /> Send Email to All Members
        </Button>
        <WrapDialogue
          ref="sendEmailDialogue"
          title={windowTitle}
          content={
            <EmailSender
              type="org"
              userId={this.props.userId}
              orgId={this.state.orgId}
              subject={this.state.orgInfoData.orgInfo.orgName}
              onComplete={() => this.refs.sendEmailDialogue.close()}
            />
          }
        />
      </div>
    );
  }

  addNewMember() {
    return (
      <div>
        <NormalFlatButton
          icon={<IconAddMember />}
          label="Add New Member"
          onClick={() => this.setState({ newMemberOpen: true })}
        />
        <Dialog
          open={this.state.newMemberOpen}
          onClose={() => {
            this.setState({ newMemberOpen: false });
          }}
        >
          <DialogContent>
            <h2
              style={{
                textAlign: "center",
                color: colors.primary,
                fontFamily: "Poppins-Regular",
              }}
            >
              Add New Member
            </h2>
            {this.state.successMessage === "" && (
              <div>
                <TextField
                  required
                  value={this.state.firstName}
                  label="First Name"
                  fullWidth
                  variant="outlined"
                  onChange={(event) => {
                    this.setState({ firstName: event.target.value });
                  }}
                  style={{ marginBottom: 10 }}
                ></TextField>
                <TextField
                  required
                  value={this.state.lastName}
                  label="Last Name"
                  fullWidth
                  onChange={(event) => {
                    this.setState({ lastName: event.target.value });
                  }}
                  variant="outlined"
                  style={{ marginBottom: 10 }}
                ></TextField>
                <TextField
                  required
                  value={this.state.email}
                  label="Email"
                  fullWidth
                  variant="outlined"
                  onChange={(event) => {
                    this.setState({ email: event.target.value });
                  }}
                  style={{ marginBottom: 10 }}
                ></TextField>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(event) => {
                        const val = this.state.isProvider;
                        this.setState({ isProvider: !val });
                      }}
                      checked={this.state.isProvider}
                      name="isProviderCheckbox"
                      color={colorsV2.primary}
                    />
                  }
                  label="Member Will See Patients"
                />
              </div>
            )}
            {this.state.addError !== "" && (
              <p style={{ color: "red", fontFamily: "Poppins-Regular" }}>
                {this.state.addError}
              </p>
            )}
            {this.state.successMessage !== "" && (
              <p style={{ color: "green", fontFamily: "Poppins-Regular" }}>
                {this.state.successMessage}
              </p>
            )}
          </DialogContent>
          <DialogActions>
            {this.state.successMessage === "" && (
              <div>
                <Button
                  variant="outlined"
                  onClick={() => {
                    this.setState({ newMemberOpen: false });
                  }}
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  variant="outlined"
                  style={{
                    backgroundColor: colors.primary,
                    color: colors.white,
                    marginLeft: 20,
                  }}
                  onClick={() => {
                    const emailRegex =
                      /^[a-zA-Z0-9\+._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
                    if (
                      this.state.firstName !== "" &&
                      this.state.lastName !== "" &&
                      this.state.email !== "" &&
                      emailRegex.test(String(this.state.email).toLowerCase())
                    ) {
                      addMemberToOrganization(
                        this.props.userId,
                        this.state.orgId,
                        this.state.firstName,
                        this.state.lastName,
                        this.state.email,
                        this.state.isProvider,
                        (ret) => {
                          events().trackUserEvent(
                            "Org-Add Provider",
                            null,
                            null,
                            null,
                            null,
                            this.props.userId,
                            null,
                            "portal",
                            null,
                            null,
                            JSON.stringify({
                              email: this.state.email,
                              orgId: this.state.orgId,
                            })
                          );
                          this.setState({
                            firstName: "",
                            lastName: "",
                            email: "",
                            addError: "",
                            isProvider: true,
                            orgMembers: ret.members,
                            successMessage: ret.message,
                          });

                          this.props.getOrgInfoData(
                            this.props.userId,
                            this.state.orgId
                          );
                          setTimeout(() => {
                            this.setState({
                              successMessage: "",
                              newMemberOpen: false,
                            });
                          }, 4000);
                        }
                      );
                    } else {
                      this.setState({
                        addError:
                          "First Name, Last Name, and Email are required fields. Please check your entry and try again.",
                      });
                    }
                  }}
                >
                  Add Member
                </Button>
              </div>
            )}
          </DialogActions>
        </Dialog>
        <InfoDialogue
          ref="addNewMemberRetMessage"
          title="Add New Member"
          content={this.state.addMemberRetMsg}
        />
      </div>
    );
  }

  viewMemberApps(userId) {
    let link = `/org-member-apps/${userId}`;
    this.props.history.push(link);
  }

  render() {
    let numMembers = _.size(
      this.state.orgMembers.filter((m) => {
        return !m.disabled;
      })
    );

    return (
      <AppFrame
        auth={this.props.auth}
        header="Manage Organization"
        optionsType="organizationMember"
        whiteLabelSettings={this.props.whiteLabelSettings}
      >
        <div style={layout.common.page}>
          <br />
          <br />
          <div style={layout.common.mainContainer}>
            <Loader
              show={this.state.isAddingMember}
              message={"Adding member..."}
            >
              <Subtitle text={this.state.orgInfoData.orgInfo.orgName} />
              <InfoText label="Number of Active Members:" value={numMembers} />
              <div style={layout.common.buttonAlign}>{this.addNewMember()}</div>
              <br />
              <br />
              <SectionTitle text="Members" />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                }}
              >
                <FormControlLabel
                  label="Show All"
                  control={
                    <Switch
                      label="Show All"
                      value={this.state.showAll}
                      onChange={() => {
                        const toggled = !this.state.showAll;
                        this.setState({ showAll: toggled });
                      }}
                    />
                  }
                />
              </div>
              <TextField
                fullWidth
                type="search"
                variant="outlined"
                onChange={(event) => {
                  this.setState({ filterText: event.target.value });
                }}
                value={this.state.filterText}
                label="Search by Member Name"
              />
              <table
                style={{
                  width: "98%",
                  minWidth: 700,
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                <tr>
                  <th></th>
                  <th>Name</th>
                  <th>Email</th>
                  <th></th>
                </tr>
                {this.state.orgMembers &&
                  sort(
                    this.state.orgMembers
                      .filter((user) =>
                        !this.state.showAll ? !user.disabled : true
                      )
                      .filter((user) => {
                        return this.state.filterText !== ""
                          ? (
                              user.userInfo.firstName +
                              " " +
                              user.userInfo.lastName
                            ).includes(this.state.filterText)
                          : true;
                      })
                  )
                    .asc([
                      (r) => r.userInfo.firstName,
                      (r) => r.userInfo.lastName,
                    ])
                    .map((user) => {
                      return (
                        <tr>
                          <td>
                            <div
                              className="user__avatar"
                              style={{
                                backgroundImage: `url(${user.userInfo.profilePhotoUrl})`,
                              }}
                            />
                          </td>
                          <td>
                            {user.userInfo.firstName +
                              " " +
                              user.userInfo.lastName}
                          </td>
                          <td>{user.userInfo.email}</td>
                          <td>
                            {!user.disabled && (
                              <Button
                                style={{ borderColor: "red", color: "red" }}
                                onClick={() => {
                                  this.setState({
                                    userToRemove: user,
                                    removeMemberOpen: true,
                                  });
                                }}
                                variant="outlined"
                              >
                                Remove Access
                              </Button>
                            )}
                            {user.disabled && (
                              <Button
                                style={{ borderColor: "green", color: "green" }}
                                onClick={() => {
                                  this.setState({
                                    userToRemove: user,
                                    grantMemberOpen: true,
                                  });
                                }}
                                variant="outlined"
                              >
                                Grant Access
                              </Button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
              </table>
            </Loader>
          </div>
          <Dialog
            open={this.state.removeMemberOpen}
            onClose={() => {
              this.state.setState({
                removeMemberOpen: false,
                userToRemove: null,
              });
            }}
          >
            <DialogContent>
              <h3
                style={{ fontFamily: "Poppins-Regular", color: colors.primary }}
              >
                Remove
                <span
                  style={{
                    textDecoration: "underline",
                    fontWeight: 600,
                    paddingLeft: 10,
                    paddingRight: 10,
                  }}
                >
                  {this.state.userToRemove &&
                    this.state.userToRemove.userInfo.firstName +
                      " " +
                      this.state.userToRemove.userInfo.lastName}
                </span>
                from the organization
              </h3>
              <p style={{ fontFamily: "Poppins-Regular" }}>
                Are you sure you want to remove this member from the
                organization?
              </p>
            </DialogContent>
            <DialogActions>
              <Button
                variant="outlined"
                onClick={() =>
                  this.setState({ removeMemberOpen: false, userToRemove: null })
                }
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  this.props.removeMemberFromOrganization(
                    this.props.userId,
                    this.state.orgId,
                    this.state.userToRemove.userId
                  );

                  events().trackUserEvent(
                    "Org-Revoke Access",
                    null,
                    null,
                    null,
                    null,
                    this.props.userId,
                    this.state.userToRemove.userId,
                    "portal",
                    null,
                    null,
                    JSON.stringify({
                      orgId: this.state.orgId,
                    })
                  );
                  this.setState({
                    removeMemberOpen: false,
                    userToRemove: null,
                  });
                }}
                variant="outlined"
                style={{ backgroundColor: "red", color: colors.white }}
              >
                Remove
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={this.state.grantMemberOpen}
            onClose={() => {
              this.state.setState({
                grantMemberOpen: false,
                userToRemove: null,
              });
            }}
          >
            <DialogContent>
              <div>
                <h3
                  style={{
                    fontFamily: "Poppins-Regular",
                    color: colors.primary,
                  }}
                >
                  Grant access
                  <span
                    style={{
                      textDecoration: "underline",
                      fontWeight: 600,
                      paddingLeft: 10,
                      paddingRight: 10,
                    }}
                  >
                    {this.state.userToRemove &&
                      this.state.userToRemove.userInfo.firstName +
                        " " +
                        this.state.userToRemove.userInfo.lastName}
                  </span>
                  to the organization
                </h3>
                <p style={{ fontFamily: "Poppins-Regular" }}>
                  Are you sure you want to grant this member access to the
                  organization?
                </p>
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                variant="outlined"
                onClick={() =>
                  this.setState({ grantMemberOpen: false, userToRemove: null })
                }
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  this.props.restoreOrgMemberAccess(
                    this.props.userId,
                    this.state.orgId,
                    this.state.userToRemove.userId
                  );

                  events().trackUserEvent(
                    "Org-Grant Access",
                    null,
                    null,
                    null,
                    null,
                    this.props.userId,
                    this.state.userToRemove.userId,
                    "portal",
                    null,
                    null,
                    JSON.stringify({
                      orgId: this.state.orgId,
                    })
                  );
                  this.setState({
                    grantMemberOpen: false,
                    userToRemove: null,
                  });
                }}
                variant="outlined"
                style={{ backgroundColor: "green", color: colors.white }}
              >
                Grant Access
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, organization, whiteLabelSettings }) {
  return {
    userId: user.userId,
    organization,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageOrganizationMembers);



// WEBPACK FOOTER //
// ./src/layout/organization/ManageOrganizationMembers.js